import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import moment from 'moment';
import Form, {FormBody, DateInput, SelectInput, FormActions} from '../../Form';
import * as api from '../../../actions/api';
import GraphView from '../../GraphView';

@inject('stationStore', 'dataSeriesStore')
@observer
class AnalysisMeteorologicalTemperature extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    params: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  @observable filters = {
    station_id: null,
    series_id: null,
    date_from: moment().add(-7, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
    period: 'Point',
  };
  @observable station = {};
  @observable stations = [];
  @observable observations = [];
  @observable dataSeriesItems = [];

  constructor(props) {
    super(props);

    this.state = {
      height: window.innerHeight,
      // product: '',
      series: 1, // props.seriesList[0].id,   // TODO Check if list is empty
      from: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      data: {
        data: [],
        categories: [],
        seriesData: [],
      },
      titleText: '',
      options: null,
    };
  }

  componentWillMount() {
    const { notify } = this.context;
    const { params: { id }, stationStore, dataSeriesStore } = this.props;

    stationStore.fetchItems()
      .then(action(stations => {
        this.stations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1);
      }))
      .catch(notify.error);
  }

  @action reset(item) {
    if (!item) { return; }
    this.observations = item;
  }

  @action onChangeStationFilter = (e) => {
    const { notify } = this.context;
    const { stationStore, dataSeriesStore } = this.props;
    const stationId = e.target.value;
    this.filters.station_id = stationId;
    stationStore.fetchDataSeries(stationId, { property: 'Continuous' })
      .then(action(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems
          .sort((a, b) => a.name > b.name ? 1 : -1);
      }))
      .catch(notify.error);
  }
  @action onChangePeriodFilter = (e) => { this.filters.period = e.target.value; }
  @action onChangeParameter = (e) => { this.filters.parameterId = e.target.value; }
  @action onChangeSeries = (e) => { this.filters.series_id = e.target.value; }
  @action onChangeDateFrom = (e) => { this.filters.date_from = e.target.value; }
  @action onChangeDateTo = (e) => { this.filters.date_to = e.target.value; }
  @action showObservations = (e) => {
    const { notify } = this.context;
    e.preventDefault();

    const er = message => notify.error({ message });
    if (!this.filters.station_id) { return er('Station filter required'); }
    if (!this.filters.series_id) { return er('Data Series filter required'); }
    if (!this.filters.date_from) { return er('Start date filter required'); }
    if (!this.filters.date_to) { return er('End date filter required'); }

    api.analysis
      .fetchAll(this.filters)
      .then((observations) => {
        this.reset(observations);

        const { date_from: dateFrom, date_to: dateTo, period: periodFilter } = this.filters;

        const titleText = `${observations.parameter_name} from ${dateFrom} to ${dateTo}`;

        const dataState = this.state.data;
        dataState.data = (
          observations.data && observations.data.map(observation => parseFloat(observation.value))
        ) || [];
        dataState.categories = (
          observations.data && observations.data.map(observation => observation.datetime)
        ) || [];

        const seriesData = (
          observations.data &&
          observations.data.map(({ datetime, value }) => {
            return [(new Date(datetime)).valueOf(), value];
          })
        ) || [];

        let seriesOptions;

        if (periodFilter === 'Point') {
          seriesOptions = [{
            name: titleText,
            data: seriesData,
          }];
        } else {
          const resolvePeriodFormat = p => {
            switch (p) {
              // case 'Point': return 'YYYY-MM-DDTHH:mm:ss+00:00';
              case 'Minute': return 'YYYY-MM-DDTHH:mm:00+00:00';
              case 'Hourly': return 'YYYY-MM-DDTHH:00:00+00:00';
              case 'Daily': return 'YYYY-MM-DDT00:00:00+00:00';
              case 'Weekly': return 'YYYY-MM-DDT00:00:00+00:00';
              // case 'Weekly':  return 'YYYY-MM-DDTHH:00:00+00:00';
              // case 'Weekly': return 'gggg ww';
              case 'Monthly': return 'YYYY-MM-01T00:00:00+00:00';
              case 'Annual': return 'YYYY-01-01T00:00:00+00:00';
              default: return 'YYYY-MM-DDTHH:mm:ss+00:00';
            }
          };

          const periodFormat = resolvePeriodFormat(periodFilter);

          const seriesDataPeriodic = _
            .groupBy(seriesData, item =>
              moment.utc(item[0]).format(periodFormat));

          const max = {};
          const min = {};
          const mean = {};

          Object.keys(seriesDataPeriodic)
            .forEach(period => {
              console.log('period', period);
              const periodData = seriesDataPeriodic[period].map(item => item[1]);
              console.log('periodData', periodData);
              max[period] = _.max(periodData);
              min[period] = _.min(periodData);
              mean[period] = _.mean(periodData);
            });

          const maxSeries = Object.keys(max)
            .map(period => ([moment.utc(period).valueOf(), max[period]]));
          const minSeries = Object.keys(min)
            .map(period => ([moment.utc(period).valueOf(), min[period]]));
          const meanSeries = Object.keys(mean)
            .map(period => ([moment.utc(period).valueOf(), mean[period]]));

          seriesOptions = [
            {
              name: 'Max',
              data: maxSeries,
            },
            {
              name: 'Min',
              data: minSeries,
            },
            {
              name: 'Average',
              data: meanSeries,
            },
          ];
        }

        const options = {
          chart: {
            type: 'line',
            zoomType: 'x',
          },
          title: {
            text: titleText,
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%e. %b',
              week: '%e. %b',
              month: '%b \'%y',
              year: '%Y',
            },
          },
          yAxis: {
            title: {
              text: '',
            },
          },
          series: seriesOptions,
        };

        this.setState({
          data: dataState,
          titleText,
          seriesData,
          options,
        });
      })
      .catch(notify.error);
  };

  render() {
    const { seriesData, options } = this.state;
    const { stationStore, parameterStore } = this.props;

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label={'Station'}
              value={this.filters.station_id}
              fields={{ label: 'name', value: 'id' }}
              filterOptions={stationStore.filterStations}
              options={this.stations}
              onChange={this.onChangeStationFilter}
            />
            <SelectInput
              label={'Data Series'}
              value={this.filters.series_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={this.onChangeSeries}
            />
            <DateInput
              label={'Date From'}
              value={this.filters.date_from}
              onChange={this.onChangeDateFrom}
            />
            <DateInput
              label={'Date To'}
              value={this.filters.date_to}
              onChange={this.onChangeDateTo}
            />
            <SelectInput
              label={'Period'}
              value={this.filters.period}
              fields={{ label: 'name', value: 'name' }}
              options={[
                { name: 'Point' },
                { name: 'Minute' },
                { name: 'Hourly' },
                { name: 'Daily' },
                { name: 'Weekly' },
                { name: 'Monthly' },
                { name: 'Annual' },
              ]}
              onChange={this.onChangePeriodFilter}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.showObservations}>View</button>
          </FormActions>
        </Form>

        <div>
          {options && <GraphView options={options} />}
        </div>

      </div>
    );
  }
}

export default AnalysisMeteorologicalTemperature;



// WEBPACK FOOTER //
// ./src/components/Analysis/Meteorological/Temperature.js